import React, {  useCallback, useEffect, useState } from 'react'
import { Breadcrumb, CardBasic, SFooter } from '../../components';
import './tab.css';
import {CustomLogo} from '../../assets/index';
import { useLocation } from 'react-router-dom';
import { API_BASE_URL } from '../../config';

function View() {
    // const navigate = useNavigate();
    const location = useLocation();
    const data = location.state;

    const [loading, setLoading] = useState(false);
    // const [error, setError] = useState(null);
    const [medicalRecord, setMedicalRecord] = useState([]);
    // console.log(data)

    const fetchData = useCallback( async () => {
        try {
            const token = localStorage.getItem('access_token');
            const response = await fetch(`${API_BASE_URL}/auth/patient/medical_record_detail/${data?.data?.klinik_id}/${data?.data?.no_medical_record}/${data?.no_regist}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token && { Authorization: `Bearer ${token}` }),
                }
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                console.log(errorData.message || 'Error fetching medical record');
                setLoading(false);
                setMedicalRecord({
                    status: false,
                    data: [],
                    message: errorData.message || 'Error fetching medical record',
                    code: response.status
                });
                return;
            }
            const datas = await response.json();
            setMedicalRecord({
                status: true,
                data: datas.data || [],
                message: 'Success',
                code: response.status
            });
            setLoading(false);
            // setError(null);
            // Process the fetched data
        } catch (error) {
            console.log('Error fetching medical record');
            setLoading(false);
            setMedicalRecord({
                status: false,
                data: [],
                message: 'Error fetching medical record',
                code: 500
            });
        }
    }, [data]);

    const handlePrint = () => {
        setTimeout(() => {
          window.print(); // Cetak dokumen
        }, 500); // Beri jeda untuk memastikan modal tertutup
    };

    const fullDate = (date) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(date).toLocaleDateString(undefined, options);
    }

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    if (loading) {
        return <div>Loading...</div>;
    }
    
    return (
        <>
        <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
            <Breadcrumb title={'Home'} header={'Doctor Review'}/>
            <div className='app-container container-xxl d-flex'>
                <div className='app-main flex-column flex-row-fluid' id="kt_app_main">
                    <div className='d-flex flex-column flex-column-fluid'>
                        <div className='app-content'>
                            <CardBasic
                            className={'mb-6 mb-xl-9'}
                            className2={'pt-9 pb-0'}
                            >
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <img src={CustomLogo} alt="Logo" className="logo-image" style={{ height: '100px',width:'150px'}} />
                                    <button className="btn btn-primary" onClick={handlePrint}>Print</button>
                                </div>

                                <div className='row d-flex'>
                                    <div className='col-lg-8 col-md-6'>
                                        <div className="mb-5 p-3">
                                            <h3 className="text-center fw-bold">Medical Record</h3>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="col-md-6">
                                                <p className="mb-1"><strong>No Medical Record:</strong> { medicalRecord?.data?.no_medical_record}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <p className="mb-1"><strong>Tempat & Tanggal Lahir:</strong> {medicalRecord?.data?.place_of_birth}, {fullDate(data?.patient?.date_of_birth)}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <p className="mb-1"><strong>Full Name:</strong> {medicalRecord?.data?.full_name}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <p className="mb-1"><strong>Jenis Kelamin:</strong> {medicalRecord?.data?.gender === 'Male' ? 'Laki-laki' : 'Perempuan'}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <p className="mb-1"><strong>No Identity:</strong> {medicalRecord?.data?.identity_number}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <p className="mb-1"><strong>No Telp:</strong> {medicalRecord?.data?.phone_number}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <p className="mb-1"><strong>Registration Date:</strong> {medicalRecord?.data?.registration_date}</p>
                                            </div>
                                        </div>

                                        <hr className="my-4" />

                                        <div className="row mb-3">
                                            <div className="col-md-12">
                                                <p className="mb-1"><strong>Information Alergy:</strong> {medicalRecord?.data?.allergy_information}</p>
                                            </div>
                                            <div className="col-md-12">
                                                <p className="mb-1"><strong>Anamnesa:</strong> {medicalRecord?.data?.anamnesa}</p>
                                            </div>
                                            <div className="col-md-12">
                                                <p className="mb-1"><strong>Recommendation:</strong> {medicalRecord?.data?.recommendation}</p>
                                            </div>
                                            <div className="col-md-12">
                                                <p className="mb-1"><strong>Notes:</strong> {medicalRecord?.data?.notes}</p>
                                            </div>
                                        </div>
                                    
                                        <hr className="my-4" />
                                    </div>
                                    <div className='col-lg-4 col-md-6'>
                                        <div className="border p-3" style={{ borderWidth: '1px', borderStyle: 'solid', borderColor: '#ddd' }}>
                                            <h5 className="text-center text-muted mb-4">Treatment & Product</h5>
                                            {medicalRecord?.data?.treatment_or_recipt?.map((treatment, index) => (
                                                <div className="mb-2" key={index}>
                                                    <p className="mb-1"><strong>Treatment & Product / Drug:</strong></p>
                                                    <p className="mb-1">{treatment} - by {medicalRecord?.data?.doctor_name}</p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className='row d-flex mt-5'>
                                    <div className='text-center mb-5 text-muted'>
                                        <h5 className='text-muted'>Dokter Pemeriksa</h5>
                                    </div>
                                    <div className='text-center mt-3 mb-5 p-3 fw-bold'>
                                        <h5>{medicalRecord?.data?.doctor_name}</h5>
                                    </div>
                                </div>
                            </CardBasic>
                        </div>
                    </div>
                    <SFooter />
                </div>
            </div>
        </div>
        </>
    )
}

export default View